import { Layers } from "lucide-react";
import { cn } from "@wa/ui";
import { useT } from "../../../../i18n/I18nProvider";
import { IconBtn } from "../../../ui";

/**
 * The switch between the flat folder and the folded one.
 *
 * The same button, the same icon and the same spot as the call log's, because
 * it is the same gesture: an operator who learns to fold one workspace screen
 * should not have to find the control again on the other. Only the wording
 * differs, and only because the two screens fold on different identities.
 *
 * A pressed toggle rather than a menu, for the reason `DensityToggle` gives:
 * there are two states, the change is visible the instant it happens, and a
 * menu would cost two clicks to say one thing.
 */
export function GroupToggle({ grouped, onToggle }: { grouped: boolean; onToggle: () => void }) {
  const t = useT();

  return (
    <IconBtn
      className={cn(grouped && "is-on")}
      onClick={onToggle}
      aria-pressed={grouped}
      aria-label={t("mail.group.toggle")}
      title={grouped ? t("mail.group.toFlat") : t("mail.group.toGrouped")}
    >
      <Layers className="size-4" />
    </IconBtn>
  );
}
